import Project from '../../../components/Project/Project'
import ArtWorkItem from '../../../components/ArtWorkItem/ArtWorkItem'
import Layout from '../../../layout/Layout'
import { hypnopompic } from '../../../resources/artWork'

const Home = () => {
  const { images } = hypnopompic
  return (
    <Layout>
      <div className='Projects'>
        <Project pr={1} {...hypnopompic}>
          {images.map(item => <ArtWorkItem {...item} />)}
        </Project>
      </div>
    </Layout>
  )
}

export default Home;